import MessageDetailsTopBar from './container'
export { MessageDetailsTopBar }
export default MessageDetailsTopBar